import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import s from './question.module.scss';
import DropdownArrowIcon from '@/shared/assets/icons/dropdown-arrow-icon.svg';
export var Question = function (_a) {
    var title = _a.title, text = _a.text;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var dropdownRef = useRef(null);
    var toggleDropdown = function () {
        setOpen(!open);
    };
    return (_jsxs("div", { className: s.question, children: [_jsxs("div", { className: s.header, onClick: toggleDropdown, children: [_jsx("h4", { className: s.title, children: title }), _jsx("button", { className: s.dropdownButton, children: _jsx(DropdownArrowIcon, { className: "".concat(s.icon, " ").concat(open ? s.icon_open : '') }) })] }), _jsx("div", { className: "".concat(s.dropdown, " ").concat(open ? s.dropdown_open : s.dropdown_hidden), ref: dropdownRef, children: _jsx("p", { className: s.text, children: text }) })] }));
};
